<template>
	<fieldset>
		<b-row v-for="(room, index) in rooms" :key="index" align-v="end" class="roomtype">
			<b-col sm="3">
				<b-form-group
					label="Nom de la catégorie"
					:label-for="'rooms_name_' + index"
					description=""
				>
					<b-form-input
						type="text"
						v-model="rooms[index].name"
						:id="'rooms_name_' + index"
						required
						placeholder="Ex. Standard, Double ..."
					>
					</b-form-input>
				</b-form-group>
			</b-col>

			<b-col>
				<b-form-group
					label="Superficie (moy.)"
					:label-for="'rooms_avg_dimensions_' + index"
					description=""
				>
					<b-input-group append="m2" class="mb-2 mr-sm-2 mb-sm-0">
						<b-form-input
							type="number"
							v-model="rooms[index].avg_dimensions"
							:id="'rooms_avg_dimensions_' + index"
							required
							placeholder=""
						>
						</b-form-input>
					</b-input-group>
				</b-form-group>
			</b-col>

			<b-col>
				<b-form-group
					label="Capacité max."
					:label-for="'rooms_max_capacity_' + index"
					description=""
				>
					<b-input-group append="pers" class="mb-2 mr-sm-2 mb-sm-0">
						<b-form-input
							type="number"
							v-model="rooms[index].max_capacity"
							:id="'rooms_max_capacity_' + index"
							required
							placeholder=""
						>
						</b-form-input>
					</b-input-group>
				</b-form-group>
			</b-col>

			<b-col>
				<b-form-group
					label="Prix à partir de"
					:label-for="'rooms_price_from_' + index"
					description=""
				>
					<b-input-group append="€" class="mb-2 mr-sm-2 mb-sm-0">
						<b-form-input
							type="number"
							v-model="rooms[index].price_from"
							:id="'rooms_price_from_' + index"
							required
							placeholder=""
						>
						</b-form-input>
					</b-input-group>
				</b-form-group>
			</b-col>
			<b-col>
				<b-button
					class="show-btn"
					@click="$bvModal.show('room-services-modal-' + index)"
					>Ajouter des services</b-button
				>
			</b-col>

			<b-col sm="1">
				<b-button
					variant="danger"
					v-on:click="removeRoomType(index)"
					:id="'delete_' + index"
				>
					&times;
				</b-button>
			</b-col>

			<b-modal
				:id="'room-services-modal-' + index"
				size="xl"
				title="Services dans la chambre"
			>
				<h3>Chambre {{ index + 1 }}</h3>

				<div
					v-for="category in room_services"
					class="room-service-category"
					:key="category.id"
				>
					<h3>{{ category.name }}</h3>
					
					<div class="checkbox-container">
						<b-form-checkbox
							v-for="(service, i) in category.service"
							v-model="rooms[index].services"
							:name="'room_service_' + i"
							:value="service.id"
							:key="service.id"
						>
							{{ service.name }}
						</b-form-checkbox>
					</div>
				</div>
			</b-modal>
		</b-row>

		<b-row>
			<b-col>
				<p class="text-center" id="add-roomtype">
					<b-button variant="outline-primary" v-on:click="addRoomType"
						>Ajouter une catégorie de chambre</b-button
					>
				</p>
			</b-col>
		</b-row>
	</fieldset>
</template>

<script>
export default {
	name: "FormRooms",
	props: ["rooms", "room_services", "selected_room_services"],
	methods: {
		addRoomType: function() {
			this.$emit(
				"update:rooms",
				this.rooms.push({
					name: "",
					avg_dimensions: "",
					max_capacity: "",
					price_from: "",
					services: this.selected_room_services
				})
			);
		},
		removeRoomType: function(index) {
			this.$bvModal
				.msgBoxConfirm("Etes-vous sur de vouloir supprimer?", {
					centered: true,
					cancelTitle: "Annuler",
					okTitle: "Supprimer"
				})
				.then(value => {
					if (value) {
						this.$emit("update:rooms", this.rooms.splice(index, 1));
					}
				});
		},
		isRoomServiceChecked: function(i) {
			return this.selected_room_services.indexOf(i) == 1;
		}
	}
};
</script>

<style lang="scss">
#app {
	.roomtype {
		margin-bottom: 30px;

		.form-group {
			display: block;
			margin-bottom: 0;

			label {
				margin: 0;
				width: 100%;
				text-align: left;
			}
		}
	}
}
</style>